<ion-content (touchstart)="onTouchStart($event)"
(touchmove)="onTouchMove($event)"
(touchend)="onTouchEnd($event)">
	<div class="wrapper">
		<div class="content">

			<header class="header">
				<img class="logo" src="assets/images/logo.svg" alt="Logo">
			</header>

			<div class="main">
				<div class="mr-potty">
					<img src="assets/images/choose-song/mr_potty_and_bubble.svg" alt="Mr Potty with bubble">
					<p class="bubble-text">What makes you wanna wiggle?</p>
				</div>

				<div class="main-content">
					<h2 class="title">Select a song that describes your experience</h2>
					<app-progress-bar [activeStep]="2"></app-progress-bar>

					<div class="songs">
						<div class="song" *ngFor="let category of songsCategories"
							(click)="toggleSelectedSongId(songsGroupedByKey[category][currentIndex].songId, category)"
							[ngClass]="selectedSongId === songsGroupedByKey[category][currentIndex].songId ? 'selected-song' : ''">
							<span class="song__title">
								{{ songsGroupedByKey[category][currentIndex].title }}
								<span class="song__author">by {{ songsGroupedByKey[category][currentIndex].artist
									}}</span>
							</span>
						</div>
					</div>
				</div>

				<span class="getting-songs" *ngIf="isGettingSongs && !this.songs.length">Getting songs..</span>

				<button class="shuffle btn-with-effect" (click)="shuffleSongs()">
					<img src="assets/images/choose-song/shuffle.svg" alt="Shuffle button">
				</button>

				<app-navigation-buttons
					(click)="saveSongMetadata($event)"
					[isSkipButtonHidden]="true"
					[nextButtonText]="nextButtonText"
					[twoButtonsShowing]="true"
					[isSkipDisplayed]="nextButtonText === 'skip'"
				></app-navigation-buttons>

			</div>

		</div>
	</div>
</ion-content>
